<template>
  <div>
    <h4 class="mb-2">用户编码：{{currentData.userCode}}</h4>
    <h4 class="mb-3">用户名称：{{currentData.userName}}</h4>

    <Card class="mb-5">
      <p slot="title">选择角色</p>
      <div style="border-bottom: 1px solid #e9e9e9;padding-bottom:6px;margin-bottom:6px;">
        <Checkbox
          :indeterminate="indeterminate_role"
          :value="checkAll_role"
          @click.prevent.native="handleCheckAll_role"
        >全选</Checkbox>
      </div>

      <CheckboxGroup v-model="checkPermissionCode_role" @on-change="checkAllGroupChange_role">
        <Checkbox
          :label="role.userRoleID"
          v-for="role in roleList"
          :key="role.userRoleID"
          border
          class="mb-3"
        >
          <span>{{role.userRoleName}}</span>
        </Checkbox>
      </CheckboxGroup>
    </Card>

    <Card>
      <p slot="title">选择功能权限（非必须）</p>
      <div style="border-bottom: 1px solid #e9e9e9;padding-bottom:6px;margin-bottom:6px;">
        <Checkbox
          :indeterminate="indeterminate_normal"
          :value="checkAll_normal"
          @click.prevent.native="handleCheckAll_normal"
        >全选</Checkbox>
      </div>

      <CheckboxGroup v-model="checkPermissionCode_normal" @on-change="checkAllGroupChange_normal">
        <Checkbox
          :label="privilege.privilegeID"
          v-for="privilege in normalPrivilegeList"
          :key="privilege.privilegeID"
          border
          class="mb-3"
        >
          <span>{{privilege.privilegeName}}</span>
        </Checkbox>
      </CheckboxGroup>
    </Card>

    <div class="ml-5 mt-5 text-center modal-foter">
      <Button @click="returnBack" class="mr-5">取 消</Button>
      <Button type="success" @click="handleSubmit()">确 定</Button>
    </div>
  </div>
</template>
<script>
export default {
  props: ["currentData"],
  data: function () {
    return {
      roleList: [], //角色
      normalPrivilegeList: [], //功能权限
      privilegeAll: [], //全部权限

      indeterminate_role: false,
      checkAll_role: false,
      checkPermissionCode_role: [],

      indeterminate_normal: true,
      checkAll_normal: false,
      checkPermissionCode_normal: [],
    };
  },

  created: function () {
    this.getRoleAll();
    this.getPrivilegeAll();
    this.getUserRoleAndPrivilege();
  },

  methods: {
    handleSubmit: function () {
      let checknormal = this.checkPermissionCode_normal;
      let checknormalArr = [];
      let that = this;
      for (let id of checknormal) {
        let privilege = that.privilegeAll.find((p) => p.privilegeID == id);
        // let obj = {
        //   PrivilegeId: id,
        //   PrivilegeType: privilege.privilegeType,
        //   PrivilegeCode: privilege.privilegeCode,
        // };
        // checknormalArr.push(obj);
        if(privilege){
          let obj = {
            PrivilegeId: id,
            PrivilegeType: privilege.privilegeType,
            PrivilegeCode: privilege.privilegeCode,
          };
          checknormalArr.push(obj);
        }
      }

      let data = {
        UserId: this.currentData.userID,
        RoleIds: this.checkPermissionCode_role,
        PrivilegeModels: checknormalArr,
      };
      this.$api.post("user/setUserRoleAndPrivilege", data).then((rsp) => {
        if (rsp != false) {
          this.$Message.success("配置成功");
          this.returnBack();
          this.$emit("loadData");
        }
      });
    },

    //获取角色all
    getRoleAll() {
      this.$api.get(`/role/getListAll`).then((rsp) => {
        if (rsp != false) {
          this.roleList = rsp.data;
        }
      });
    },

    //获取功能权限
    getPrivilegeAll() {
      this.$api.get(`/privilege/getListAll`).then((rsp) => {
        if (rsp != false) {
          this.privilegeAll = rsp.data;
          this.normalPrivilegeList = this.privilegeAll.filter(
            (p) => p.privilegeType == "1"
          );
        }
      });
    },

    //获取当前用户的角色和权限
    getUserRoleAndPrivilege() {
      let userId = this.currentData.userID;
      this.$api
        .post(`/user/getUserRoleAndPrivilege?userId=${userId}`)
        .then((rsp) => {
          if (rsp != false) {
            let result = rsp.data;
            this.checkPermissionCode_role = result.roleIds;
            this.checkPermissionCode_normal = result.privilegeIds;
          }
        });
    },

    returnBack: function () {
      this.$emit("close");
    },

    handleCheckAll_role() {
      if (this.indeterminate_role) {
        this.checkAll_role = false;
      } else {
        this.checkAll_role = !this.checkAll_role;
      }
      this.indeterminate_role = false;
      if (this.checkAll_role) {
        let allPages = [];
        this.roleList.forEach((item) => {
          allPages.push(item.userRoleID);
        });
        this.checkPermissionCode_role = allPages;
      } else {
        this.checkPermissionCode_role = [];
      }
    },

    checkAllGroupChange_role(data) {
      if (data.length === this.roleList.length) {
        this.indeterminate_role = false;
        this.checkAll_role = true;
      } else if (data.length > 0) {
        this.indeterminate_role = true;
        this.checkAll_role = false;
      } else {
        this.indeterminate_role = false;
        this.checkAll_role = false;
      }
    },

    handleCheckAll_normal() {
      if (this.indeterminate_normal) {
        this.checkAll_normal = false;
      } else {
        this.checkAll_normal = !this.checkAll_normal;
      }
      this.indeterminate_normal = false;
      if (this.checkAll_normal) {
        let allPages = [];
        this.normalPrivilegeList.forEach((item) => {
          allPages.push(item.privilegeID);
        });
        this.checkPermissionCode_normal = allPages;
      } else {
        this.checkPermissionCode_normal = [];
      }
    },

    checkAllGroupChange_normal(data) {
      if (data.length === this.normalPrivilegeList.length) {
        this.indeterminate_normal = false;
        this.checkAll_normal = true;
      } else if (data.length > 0) {
        this.indeterminate_normal = true;
        this.checkAll_normal = false;
      } else {
        this.indeterminate_normal = false;
        this.checkAll_normal = false;
      }
    },
  },
};
</script>
<style scoped>
</style>